import { RouteReuseStrategy, DetachedRouteHandle, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

/**
 * Keeps LocationListComponent alive when navigating to a location detail page
 * so the full state (map, results, AI search, filters) is restored instantly on back.
 * Routes opt in via data: { reuse: true }.
 */
@Injectable()
export class LocationListReuseStrategy implements RouteReuseStrategy {
  private stored: DetachedRouteHandle | null = null;

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return !!route.data?.['reuse'];
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    if (route.data?.['reuse']) {
      this.stored = handle;
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return !!route.data?.['reuse'] && !!this.stored;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return route.data?.['reuse'] ? this.stored : null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}
